import {BaseContainerModel} from '../../base-container.model';
import {
  multiple_event_expenses_report_line_RowClass,
} from '../../../dbschema';

export class MultipleEventExpensesReportsContainerModel extends BaseContainerModel {
  event_expenses_report_line: multiple_event_expenses_report_line_RowClass = new multiple_event_expenses_report_line_RowClass();
}
